import { Link } from "react-router-dom";
import { ArrowRight, Calendar, Clock } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import Navbar from "./Navbar";
import NewsletterSubscribe from "./NewsletterSubscribe";
import Footer from "./Footer";

function ArticleCard({ article, index }) {
  return (
    <Link to={`/blog/${article.slug}`} data-testid={`blog-card-${index}`}
      className="group block bg-[#162A45] border border-slate-800 hover:border-[#D4AF37]/40 transition-all duration-500 overflow-hidden">
      <div className="h-48 overflow-hidden">
        <img src={article.image} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
        <div className="relative -mt-48 h-48 bg-gradient-to-t from-[#111C30] to-transparent" />
      </div>
      <div className="p-8 pt-2">
        <div className="flex items-center gap-4 mb-4">
          <span className="text-[#D4AF37] text-[10px] uppercase tracking-widest font-medium">{article.category}</span>
          <div className="flex items-center gap-1.5 text-slate-600 text-xs">
            <Clock size={11} />
            <span>{article.readTime}</span>
          </div>
        </div>
        <h3 className="text-white text-lg font-semibold mb-3 group-hover:text-[#D4AF37] transition-colors duration-300 leading-snug"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          {article.title}
        </h3>
        <p className="text-slate-300 text-sm leading-relaxed mb-5 line-clamp-3">{article.excerpt}</p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1.5 text-slate-600 text-xs">
            <Calendar size={11} />
            <span>{article.date}</span>
          </div>
          <span className="text-[#D4AF37] text-xs uppercase tracking-widest flex items-center gap-1 group-hover:gap-2 transition-all duration-300">
            Read <ArrowRight size={12} />
          </span>
        </div>
      </div>
    </Link>
  );
}

export default function Blog() {
  const { t } = useLanguage();
  const b = t.blog;

  return (
    <main className="bg-[#0F1A2E] min-h-screen">
      <Navbar />
      <section className="pt-32 pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="mb-16">
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-12 bg-[#D4AF37]" />
              <span className="text-[#D4AF37] text-xs uppercase tracking-widest">{b.label}</span>
            </div>
            <h1 className="text-4xl md:text-5xl text-white leading-tight mb-4"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
              {b.heading}
            </h1>
            <p className="text-slate-300 text-base max-w-2xl">{b.desc}</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {b.articles.map((article, i) => (
              <ArticleCard key={article.slug} article={article} index={i} />
            ))}
          </div>
        </div>
      </section>
      <NewsletterSubscribe />
      <Footer />
    </main>
  );
}
